"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynatraceWrapper = void 0;
const core_1 = require("../core");
const monitoringService_1 = require("../monitoring/monitoringService");
/**
 * Wrapper class for Dynatrace monitoring service.
 */
class DynatraceWrapper {
    constructor() {
        if (typeof window !== 'undefined' && window.dtrum) {
            this.dtrum = window.dtrum;
        }
        else {
            core_1.Log.error('Dynatrace (dtrum) is not available on window.');
        }
    }
    setActionName(actionName, actionId) {
        if (this.dtrum && this.dtrum.actionName) {
            return this.dtrum.actionName(actionName, actionId);
        }
        core_1.Log.error('actionName is not available on dtrum.');
        return -1 /* ActionNameResult.FAILURE */;
    }
    startAction(actionName, actionType, startTime, sourceUrl) {
        if (this.dtrum && this.dtrum.enterAction) {
            return this.dtrum.enterAction(actionName, actionType, startTime, sourceUrl);
        }
        core_1.Log.error('enterAction is not available on dtrum.');
        return -1;
    }
    endAction(actionId, stopTime, startTime) {
        if (this.dtrum && this.dtrum.leaveAction) {
            this.dtrum.leaveAction(actionId, stopTime, startTime);
        }
        else {
            core_1.Log.error('leaveAction is not available on dtrum.');
        }
    }
    logCustomError(key, value, hint, parentingInfo) {
        if (this.dtrum && this.dtrum.reportCustomError) {
            this.dtrum.reportCustomError(key, value, hint, parentingInfo);
        }
        else {
            core_1.Log.error('reportCustomError is not available on dtrum.');
        }
    }
    logError(error, parentActionId) {
        if (this.dtrum && this.dtrum.reportError) {
            this.dtrum.reportError(error, parentActionId);
        }
        else {
            core_1.Log.error('reportError is not available on dtrum.');
        }
    }
    changePage(newPage) {
        if (this.dtrum && this.dtrum.setPage) {
            return this.dtrum.setPage(newPage);
        }
        core_1.Log.error('setPage is not available on dtrum.');
        return monitoringService_1.PageChangeResult.FAILURE;
    }
}
exports.DynatraceWrapper = DynatraceWrapper;
//# sourceMappingURL=dynatrace.js.map